module.exports = __webpack_public_path__ + "img/喜报2.643a14ad.jpg";